import React, { useState, useCallback, useEffect, useRef } from 'react';
import { DateInputOld as DateInput } from '../../../../common/Input';
import axios from '../../../../api/apiClient';
import {
  domain,
  token,
  globalTimeFormat,
  ALLOW_LEAVE_CREDITS_MODULE
} from '../../../Security';
import { FEATURES } from '../../../../config/features';
import { useSalaryRateMatcher } from '../../../../v2/hooks/useSalaryRateMatcher';
import SalaryRateCategorySelect from '../../../../common/selectComponents/SalaryRateCategorySelect';
import { SALARY_FILTER_MAP } from '../../../../v2/components/filters/FilterConfig';

export function InformationTab({
  locationId,
  dateEmployed,
  dateRegular,
  dateProbationary,
  dateProjectBase,
  dateContractual,
  dateResigned,
  employmentId,
  departmentId,
  sectionId,
  classificationId,
  payTypeId,
  shiftScheduleId,
  positionId,
  salaryType,
  setLocationId,
  setDateEmployed,
  setDateRegular,
  setDateProbationary,
  setDateProjectBase,
  setDateContractual,
  setDateResigned,
  setEmploymentId,
  setDepartmentId,
  setSectionId,
  setClassificationId,
  setPayTypeId,
  setShiftScheduleId,
  setPositionId,
  setSalaryType,
  sickLeave,
  setSickLeave,
  vacationLeave,
  setVacationLeave,
  employeeStatus,
  setEmployeeStatus,
  serviceIncentiveLeave,
  setServiceIncentiveLeave,
  soloParentLeave,
  setSoloParentLeave,

  sickRemaining,
  setSickRemaining,
  vacationRemaining,
  setVacationRemaining,
  serviceIncentiveRemaining,
  setServiceIncentiveRemaining,
  soloParentRemaining,
  setSoloParentRemaining,

  jobTitleId, setJobTitleId,
  employeeGroup1Id, setEmployeeGroup1Id,
  employeeGroup2Id, setEmployeeGroup2Id,
  plantilyaId,
  setPlantilyaId,
  costCenterId,
  setCostCenterId,
  clientId,
  setClientId,

  employeeRestDays, setEmployeeRestDays,
  employeeTypeId, setEmployeeTypeId,
  vesselId, setVesselId,
  destinationId, setDestinationId,

  effectiveFrom, setEffectiveFrom,
  contractFrom, setContractFrom,
  contractTo, setContractTo,

  maintenanceSalaryCombinationV2Id,
  setmaintenanceSalaryCombinationV2Id,

  isEditMode,
  isAddMode = false
}) {
  const [isMonday, setIsMonday] = useState(false);
  const [isTuesday, setIsTuesday] = useState(false);
  const [isWednesday, setIsWednesday] = useState(false);
  const [isThursday, setIsThursday] = useState(false);
  const [isFriday, setIsFriday] = useState(false);
  const [isSaturday, setIsSaturday] = useState(false);
  const [isSunday, setIsSunday] = useState(false);

  const [isInitOnce, setIsInitOnce] = useState(false);

  useEffect(() => {
    if (!isInitOnce) {
      setIsInitOnce(true);

      const haveMonday = employeeRestDays.find(data => data.day === "Monday");
      const haveTuesday = employeeRestDays.find(data => data.day === "Tuesday");
      const haveWednesday = employeeRestDays.find(data => data.day === "Wednesday");
      const haveThursday = employeeRestDays.find(data => data.day === "Thursday");
      const haveFriday = employeeRestDays.find(data => data.day === "Friday");
      const haveSaturday = employeeRestDays.find(data => data.day === "Saturday");
      const haveSunday = employeeRestDays.find(data => data.day === "Sunday");

      setIsMonday(haveMonday ? true : false);
      setIsTuesday(haveTuesday ? true : false);
      setIsWednesday(haveWednesday ? true : false);
      setIsThursday(haveThursday ? true : false);
      setIsFriday(haveFriday ? true : false);
      setIsSaturday(haveSaturday ? true : false);
      setIsSunday(haveSunday ? true : false);
    }
  }, [employeeRestDays, isInitOnce])

  useEffect(() => {
    const days = [
      { day: 'Monday', isRestDay: isMonday },
      { day: 'Tuesday', isRestDay: isTuesday },
      { day: 'Wednesday', isRestDay: isWednesday },
      { day: 'Thursday', isRestDay: isThursday },
      { day: 'Friday', isRestDay: isFriday },
      { day: 'Saturday', isRestDay: isSaturday },
      { day: 'Sunday', isRestDay: isSunday },
    ];

    // Filter the days where isRestDay is true and map them to the desired format
    const restDays = days
      .filter(dayObj => dayObj.isRestDay)
      .map(dayObj => ({
        day: dayObj.day,
      }));
    // Set the state with the rest days
    setEmployeeRestDays(restDays);
  }, [isMonday, isTuesday, isWednesday, isThursday, isFriday, isSaturday, isSunday, setEmployeeRestDays])


  const filterState = {
    departmentId,
    positionId,
    employeeTypeId,
    vesselId,
    locationId,
    clientId,
    classificationId,
    payTypeId
  };

  const { matchedRules, loading: loadingRules } = useSalaryRateMatcher(filterState, salaryType, SALARY_FILTER_MAP);

  return (
    <div className="information-tab column">
      <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Effectivity Date</div>
          <div className="info-item-input">{DateInput(effectiveFrom, setEffectiveFrom, isAddMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Contract From</div>
          <div className="info-item-input">{DateInput(contractFrom, setContractFrom, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Contract To</div>
          <div className="info-item-input">{DateInput(contractTo, setContractTo, isEditMode)}</div>
        </div>
      </div>

      <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Location</div>
          <div className="info-item-input">{LocationIdSelect(locationId, setLocationId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Employed</div>
          <div className="info-item-input">{DateInput(dateEmployed, setDateEmployed, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Regular</div>
          <div className="info-item-input">{DateInput(dateRegular, setDateRegular, isEditMode)}</div>
        </div>
      </div>

      <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Probationary</div>
          <div className="info-item-input">{DateInput(dateProbationary, setDateProbationary, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Project Base</div>
          <div className="info-item-input">{DateInput(dateProjectBase, setDateProjectBase, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Contractual</div>
          <div className="info-item-input">{DateInput(dateContractual, setDateContractual, isEditMode)}</div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Employment</div>
          <div className="info-item-input">{EmploymentId(employmentId, setEmploymentId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>{FEATURES.DEPARTMENT_LABEL_UNITDEPARTMENT ? "Unit/Department" : "Department"}</div>
          <div className="info-item-input">{DepartmentIdSelect(departmentId, setDepartmentId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Section</div>
          <div className="info-item-input">{SectionIdSelect(sectionId, setSectionId, isEditMode)}</div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Classification</div>
          <div className="info-item-input">{ClassificationIdSelect(classificationId, setClassificationId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Pay Type</div>
          <div className="info-item-input">{PayTypeIdSelect(payTypeId, setPayTypeId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Shift Schedule</div>
          <div className="info-item-input">{ShiftScheduleIdSelect(shiftScheduleId, setShiftScheduleId, isEditMode)}</div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>{FEATURES.POSITION_LABEL_REGULAR_TITLE ? "Regular Title" : "Position"}</div>
          <div className="info-item-input">{PositionIdSelect(positionId, setPositionId, isEditMode, departmentId)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Destination</div>
          <div className="info-item-input">
            <DestinationIdSelect destinationId={destinationId} setDestinationId={setDestinationId} isEditMode={isEditMode} />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Employee Status</div>
          <div className="info-item-input">
            <EmployeeStatus employeeStatus={employeeStatus} setEmployeeStatus={setEmployeeStatus} isEditMode={isEditMode} />
          </div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Job Title</div>
          <div className="info-item-input">
            <JobTitleIdSelect jobTitleId={jobTitleId} setJobTitleId={setJobTitleId} isEditMode={isEditMode} />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Employee Group 1</div>
          <div className="info-item-input">
            <EmployeeGroup1IdSelect employeeGroup1Id={employeeGroup1Id} setEmployeeGroup1Id={setEmployeeGroup1Id} isEditMode={isEditMode} />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Employee Group 2</div>
          <div className="info-item-input">
            <EmployeeGroup2IdSelect employeeGroup2Id={employeeGroup2Id} setEmployeeGroup2Id={setEmployeeGroup2Id} isEditMode={isEditMode} />
          </div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Plantilya</div>
          <div className="info-item-input">
            <PlantilyaIdSelect plantilyaId={plantilyaId} setPlantilyaId={setPlantilyaId} isEditMode={isEditMode} />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Cost Center</div>
          <div className="info-item-input">
            <CostCenterSelect costCenterId={costCenterId} setCostCenterId={setCostCenterId} isEditMode={isEditMode} />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Client</div>
          <div className="info-item-input">
            <ClientIdSelect clientId={clientId} setClientId={setClientId} isEditMode={isEditMode} />
          </div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Employee Type</div>
          <div className="info-item-input">
            <EmployeeTypeIdSelect employeeTypeId={employeeTypeId} setEmployeeTypeId={setEmployeeTypeId} isEditMode={isEditMode} />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Vessel</div>
          <div className="info-item-input">
            <VesselIdSelect vesselId={vesselId} setVesselId={setVesselId} isEditMode={isEditMode} />
          </div>
        </div>
        {!isAddMode && (
          <div className="info-item info-item3 column">
            <div className="info-item-label">Date Resigned</div>
            <div className="info-item-input">{DateInput(dateResigned, setDateResigned, isEditMode)}</div>
          </div>
        )}
      </div>

      <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{ alignItems: "center" }}>Salary Type</div>
          <div className="info-item-input">
            <SalaryType salaryType={salaryType} setSalaryType={setSalaryType} isEditMode={isEditMode} />
          </div>
        </div>

        {salaryType === "MaintenanceSalaryCombination" && (
          <div className="info-item info-item3 column">
            <div className="info-item-label row" style={{ alignItems: "center" }}>
              Rate Category Selection {loadingRules && "..."}
            </div>
            <div className="info-item-input">
              <SalaryRateCategorySelect
                value={maintenanceSalaryCombinationV2Id}
                onChange={setmaintenanceSalaryCombinationV2Id}
                rules={matchedRules}
                loading={loadingRules}
                isEditMode={isEditMode}
              />
            </div>
          </div>
        )}
      </div>

      {/* Toggler when developing the module shit if it is done/functional, otherwise bring this shit back */}
      {!ALLOW_LEAVE_CREDITS_MODULE && (
        // To be remove once the Leave Credit shit is done
        <>
          <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Vacation Leave</div>
              <div className="info-item-input">
                <input id="AddEmployee-VacationLeave" placeholder="Vacation leave amount"
                  type="number" value={vacationLeave} onChange={(e) => setVacationLeave(e.target.value)}
                  readOnly={!isEditMode}
                />
              </div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Sick Leave</div>
              <div className="info-item-input">
                <input id="AddEmployee-SickLeave" placeholder="Sick leave amount"
                  type="number" value={sickLeave} onChange={(e) => setSickLeave(e.target.value)}
                  readOnly={!isEditMode}
                />
              </div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Service Incentive Leave</div>
              <div className="info-item-input">
                <input id="AddEmployee-ServiceIncentiveLeave" placeholder="Service incentive leave amount"
                  type="number" value={serviceIncentiveLeave} onChange={(e) => setServiceIncentiveLeave(e.target.value)}
                  readOnly={!isEditMode}
                />
              </div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Solo Parent Leave</div>
              <div className="info-item-input">
                <input id="AddEmployee-SoloParentLeave" placeholder="Service incentive leave amount"
                  type="number" value={soloParentLeave} onChange={(e) => setSoloParentLeave(e.target.value)}
                  readOnly={!isEditMode}
                />
              </div>
            </div>
          </div>

          <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Vacation Remaining Leave</div>
              <div className="info-item-input">
                <input id="AddEmployee-VacationRemaining" placeholder="Vacation leave remaining amount"
                  type="number" value={vacationRemaining} onChange={(e) => setVacationRemaining(e.target.value)}
                  readOnly={!isEditMode}
                />
              </div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Sick Remaining Leave</div>
              <div className="info-item-input">
                <input id="AddEmployee-SickRemaining" placeholder="Sick leave remaining amount"
                  type="number" value={sickRemaining} onChange={(e) => setSickRemaining(e.target.value)}
                  readOnly={!isEditMode}
                />
              </div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Service Incentive Remaining Leave</div>
              <div className="info-item-input">
                <input id="AddEmployee-ServiceIncentiveRemaining" placeholder="Service incentive leave remaining amount"
                  type="number" value={serviceIncentiveRemaining} onChange={(e) => setServiceIncentiveRemaining(e.target.value)}
                  readOnly={!isEditMode}
                />
              </div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Solo Parent Remaining Leave</div>
              <div className="info-item-input">
                <input id="AddEmployee-SoloParentRemaining" placeholder="Service incentive leave remaining amount"
                  type="number" value={soloParentRemaining} onChange={(e) => setSoloParentRemaining(e.target.value)}
                  readOnly={!isEditMode}
                />
              </div>
            </div>
          </div>
        </>
      )}
      <div style={{ border: "1px solid rgba(0, 0, 0, 0.357)", padding: "20px 5px", margin: "20px 0" }}>
        <div className="info-item-label row" style={{ alignItems: "center" }}>Restday/s</div>
        <div className="information-tab-itemHolder info-item-holder row" style={{ justifyContent: "space-evenly" }}>
          <div className="info-item column">
            <div className="info-item-label row" style={{ alignItems: "center" }}>Monday</div>
            <div className="info-item-input">
              <input
                type="checkbox"
                id="overtime-allowance"
                className="checkbox"
                name=""
                checked={isMonday}
                onChange={(e) => setIsMonday(e.target.checked)}
                disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item column">
            <div className="info-item-label row" style={{ alignItems: "center" }}>Tuesday</div>
            <div className="info-item-input">
              <input
                type="checkbox"
                id="overtime-allowance"
                className="checkbox"
                name=""
                checked={isTuesday}
                onChange={(e) => setIsTuesday(e.target.checked)}
                disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item column">
            <div className="info-item-label row" style={{ alignItems: "center" }}>Wednesday</div>
            <div className="info-item-input">
              <input
                type="checkbox"
                id="overtime-allowance"
                className="checkbox"
                name=""
                checked={isWednesday}
                onChange={(e) => setIsWednesday(e.target.checked)}
                disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item column">
            <div className="info-item-label row" style={{ alignItems: "center" }}>Thursday</div>
            <div className="info-item-input">
              <input
                type="checkbox"
                id="overtime-allowance"
                className="checkbox"
                name=""
                checked={isThursday}
                onChange={(e) => setIsThursday(e.target.checked)}
                disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item column">
            <div className="info-item-label row" style={{ alignItems: "center" }}>Friday</div>
            <div className="info-item-input">
              <input
                type="checkbox"
                id="overtime-allowance"
                className="checkbox"
                name=""
                checked={isFriday}
                onChange={(e) => setIsFriday(e.target.checked)}
                disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item column">
            <div className="info-item-label row" style={{ alignItems: "center" }}>Saturday</div>
            <div className="info-item-input">
              <input
                type="checkbox"
                id="overtime-allowance"
                className="checkbox"
                name=""
                checked={isSaturday}
                onChange={(e) => setIsSaturday(e.target.checked)}
                disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item column">
            <div className="info-item-label row" style={{ alignItems: "center" }}>Sunday</div>
            <div className="info-item-input">
              <input
                type="checkbox"
                id="overtime-allowance"
                className="checkbox"
                name=""
                checked={isSunday}
                onChange={(e) => setIsSunday(e.target.checked)}
                disabled={!isEditMode}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function LocationIdSelect(locationId, setLocationId, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setLocationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Location/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (locationId !== "" && locationId !== 0 && locationId !== null && locationId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [locationId]);

  useEffect(() => {
    if (locationId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === locationId.toString());

      if (!foundData) {
        setLocationId("")
      }
    }

  }, [data, locationId, setLocationId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={locationId || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function EmploymentId(employmentId, setEmploymentId, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setEmploymentId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Employment/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (employmentId !== "" && employmentId !== 0 && employmentId !== null && employmentId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [employmentId]);

  useEffect(() => {
    if (employmentId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === employmentId.toString());

      if (!foundData) {
        setEmploymentId("")
      }
    }

  }, [data, employmentId, setEmploymentId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employmentId || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function DepartmentIdSelect(departmentId, setDepartmentId, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setDepartmentId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Department/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (departmentId !== "" && departmentId !== 0 && departmentId !== null && departmentId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [departmentId]);

  useEffect(() => {
    if (departmentId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === departmentId.toString());

      if (!foundData) {
        setDepartmentId("")
      }
    }

  }, [data, departmentId, setDepartmentId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={departmentId || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function SectionIdSelect(sectionId, setSectionId, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setSectionId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Section/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (sectionId !== "" && sectionId !== 0 && sectionId !== null && sectionId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [sectionId]);

  useEffect(() => {
    if (sectionId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === sectionId.toString());

      if (!foundData) {
        setSectionId("")
      }
    }

  }, [data, sectionId, setSectionId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={sectionId || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function ClassificationIdSelect(classificationId, setClassificationId, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Classification/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (classificationId !== "" && classificationId !== 0 && classificationId !== null && classificationId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [classificationId]);

  useEffect(() => {
    if (classificationId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === classificationId.toString());

      if (!foundData) {
        setClassificationId("")
      }
    }

  }, [data, classificationId, setClassificationId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={classificationId || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function PayTypeIdSelect(payTypeId, setPayTypeId, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setPayTypeId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/PayType/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (payTypeId !== "" && payTypeId !== 0 && payTypeId !== null && payTypeId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [payTypeId]);

  useEffect(() => {
    if (payTypeId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === payTypeId.toString());

      if (!foundData) {
        setPayTypeId("")
      }
    }

  }, [data, payTypeId, setPayTypeId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={payTypeId || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function ShiftScheduleIdSelect(shiftScheduleId, setShiftScheduleId, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setShiftScheduleId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/ShiftSchedule";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (shiftScheduleId !== "" && shiftScheduleId !== 0 && shiftScheduleId !== null && shiftScheduleId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [shiftScheduleId]);

  useEffect(() => {
    if (shiftScheduleId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === shiftScheduleId.toString());

      if (!foundData) {
        setShiftScheduleId("")
      }
    }

  }, [data, shiftScheduleId, setShiftScheduleId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={shiftScheduleId || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((shiftScheduleId) => (
          SetShiftScheduleId(shiftScheduleId)
        ))}
      </select>
    </div>
  );
};
function PositionIdSelect(positionId, setPositionId, isEditMode, departmentId) {
  const [isSelected, setIsSelected] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);

    // BACKWARD COMPATIBILITY LOGIC:
    // If departmentId is provided (not null/undefined/empty string), use the filtered endpoint.
    // Otherwise, use the original general active endpoint.
    const apiUrl = (departmentId && departmentId !== "" && departmentId !== 0)
      ? `${domain}/api/Position/active/department/${departmentId}`
      : `${domain}/api/Position/active`;

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data);
      })
      .catch(error => {
        console.error('Error fetching positions:', error);
        setData([]);
      })
      .finally(() => setLoading(false));
  }, [departmentId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // VALIDATION / AUTO-RESET:
  // We only want to automatically clear the selection if we are in "Filtered Mode" 
  // (i.e., a departmentId is actually being used).
  useEffect(() => {
    if (departmentId && positionId && data.length > 0) {
      const found = data.find(i => i.id.toString() === positionId.toString());
      if (!found) {
        setPositionId("");
      }
    }
  }, [data, positionId, setPositionId, departmentId]);

  useEffect(() => {
    setIsSelected(!!(positionId && positionId !== 0));
  }, [positionId]);

  return (
    <div>
      <select
        id="employee-select-Position"
        disabled={!isEditMode}
        value={positionId || ''}
        onChange={(e) => {
          setIsSelected(true);
          setPositionId(e.target.value);
        }}
        style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}
      >
        <option value="">-- Select Position --</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.code ? `(${x.code})- ${x.description}` : x.description}
          </option>
        ))}
      </select>
      {loading && <span style={{ fontSize: '9px', color: '#3b82f6', marginLeft: '4px' }}>Loading...</span>}
    </div>
  );
}
function JobTitleIdSelect({ jobTitleId, setJobTitleId, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setJobTitleId(Number(event.target.value));
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/JobTitle/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (jobTitleId !== "" && jobTitleId !== 0 && jobTitleId !== null && jobTitleId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [jobTitleId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={jobTitleId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function EmployeeGroup1IdSelect({ employeeGroup1Id, setEmployeeGroup1Id, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setEmployeeGroup1Id(Number(event.target.value));
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/EmployeeGroup1/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (employeeGroup1Id !== "" && employeeGroup1Id !== 0 && employeeGroup1Id !== null && employeeGroup1Id !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [employeeGroup1Id]);

  useEffect(() => {
    if (employeeGroup1Id) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === employeeGroup1Id.toString());

      if (!foundData) {
        setEmployeeGroup1Id("")
      }
    }

  }, [data, employeeGroup1Id, setEmployeeGroup1Id]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employeeGroup1Id || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function EmployeeGroup2IdSelect({ employeeGroup2Id, setEmployeeGroup2Id, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setEmployeeGroup2Id(Number(event.target.value));
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/EmployeeGroup2/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (employeeGroup2Id !== "" && employeeGroup2Id !== 0 && employeeGroup2Id !== null && employeeGroup2Id !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [employeeGroup2Id]);

  useEffect(() => {
    if (employeeGroup2Id) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === employeeGroup2Id.toString());

      if (!foundData) {
        setEmployeeGroup2Id("")
      }
    }

  }, [data, employeeGroup2Id, setEmployeeGroup2Id]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employeeGroup2Id || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function PlantilyaIdSelect({ plantilyaId, setPlantilyaId, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setPlantilyaId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Plantilya/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (plantilyaId !== "" && plantilyaId !== 0 && plantilyaId !== null && plantilyaId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [plantilyaId]);

  useEffect(() => {
    if (plantilyaId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === plantilyaId.toString());

      if (!foundData) {
        setPlantilyaId("")
      }
    }

  }, [data, plantilyaId, setPlantilyaId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={plantilyaId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function CostCenterSelect({ costCenterId, setCostCenterId, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setCostCenterId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/CostCenter/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (costCenterId !== "" && costCenterId !== 0 && costCenterId !== null && costCenterId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [costCenterId]);

  useEffect(() => {
    if (costCenterId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === costCenterId.toString());

      if (!foundData) {
        setCostCenterId("")
      }
    }

  }, [data, costCenterId, setCostCenterId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={costCenterId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((costCenter) => (
          <option key={costCenter.id} value={costCenter.id}>
            {costCenter.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function ClientIdSelect({ clientId, setClientId, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClientId(Number(event.target.value));
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Client/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (clientId !== "" && clientId !== 0 && clientId !== null && clientId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [clientId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={clientId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((item) => (
          <option key={item.id} value={item.id}>
            {item.description}
          </option>
        ))}
      </select>
    </div>
  );
};
function EmployeeTypeIdSelect({ employeeTypeId, setEmployeeTypeId, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setEmployeeTypeId(Number(event.target.value));
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/EmployeeType/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (employeeTypeId !== "" && employeeTypeId !== 0 && employeeTypeId !== null && employeeTypeId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [employeeTypeId]);

  useEffect(() => {
    if (employeeTypeId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === employeeTypeId.toString());

      if (!foundData) {
        setEmployeeTypeId("")
      }
    }

  }, [data, employeeTypeId, setEmployeeTypeId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employeeTypeId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
}
function VesselIdSelect({ vesselId, setVesselId, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setVesselId(Number(event.target.value));
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Vessel/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (vesselId !== "" && vesselId !== 0 && vesselId !== null && vesselId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [vesselId]);

  useEffect(() => {
    if (vesselId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === vesselId.toString());

      if (!foundData) {
        setVesselId("")
      }
    }

  }, [data, vesselId, setVesselId]);
  return (
    <div>
      <select id="vessel-select" disabled={!isEditMode} value={vesselId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((vessel) => (
          <option key={vessel.id} value={vessel.id}>
            {vessel.code || vessel.name || `Vessel ${vessel.id}`}
          </option>
        ))}
      </select>
    </div>
  );
}
function DestinationIdSelect({ destinationId, setDestinationId, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    await axios.get(`${domain}/api/Destination/active`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(response => {
        setData(response.data);
      })
      .catch(error => console.error('Error fetching data:', error));
  };

  useEffect(() => {
    fetchData();
    setIsSelected(!!destinationId && destinationId !== 0);
  }, [destinationId]);

  return (
    <div>
      <select disabled={!isEditMode} value={destinationId || ""}
        onChange={(e) => { setIsSelected(true); setDestinationId(Number(e.target.value)); }}
        style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.id}>{x.code}</option>
        ))}
      </select>
    </div>
  );
}
function EmployeeStatus({ employeeStatus, setEmployeeStatus, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setEmployeeStatus(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/EmployeeStatusMaintenance/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (employeeStatus !== "" && employeeStatus !== 0 && employeeStatus !== null && employeeStatus !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [employeeStatus]);

  useEffect(() => {
    if (employeeStatus) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.description === employeeStatus);

      if (!foundData) {
        setEmployeeStatus("")
      }
    }

  }, [data, employeeStatus, setEmployeeStatus]);

  return (
    <div>
      <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employeeStatus || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        {data.map((x) => (
          <option key={x.id} value={x.description}>
            {x.description}
          </option>
        ))}
      </select>
    </div>
  );
}
function SalaryType({ salaryType, setSalaryType, isEditMode }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setSalaryType(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (salaryType !== "" && salaryType !== 0 && salaryType !== null && salaryType !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [salaryType]);

  return (
    <div>
      <select disabled={!isEditMode} value={salaryType || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        <option value="Daily">Daily</option>
        <option value="Monthly">Monthly</option>
        <option value="QuotaBased">Quota-Based</option>
        <option value="PositionDesignation">Position - Designation</option>
        <option value="MaintenanceSalaryCombination">Maintenance Salary Combonation</option>
      </select>
    </div>
  );
}
function SetShiftScheduleId(shiftScheduleId) {
  const formatTime = (time) => {
    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split('T');
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(':');
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split('T');
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(':');
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return formattedTime;
  }

  return (
    <option key={shiftScheduleId.id} id={"overtimeAdd" + shiftScheduleId.id} value={shiftScheduleId.id}>{`${shiftScheduleId.id} -  ${shiftScheduleId.shiftName} (${formatTime(shiftScheduleId.timeFrom)} - ${formatTime(shiftScheduleId.timeTo)}) `}</option>
  )
}